<template>
  <div class="dte-grid">
    <section class="dte-card">
      <div class="dte-card__header">Receptor</div>
      <div class="dte-card__body">
        <div
          class="dte-grid dte-grid--2 dte-recipient-grid"
        >
          <div class="dte-definition-list">
            <div class="dte-definition-list__row" v-if="showCustomerCode && documentData.receiver.code">
              <dt>{{ customerCodeLabel }}</dt>
              <dd>{{ documentData.receiver.code }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Razon social</dt>
              <dd>{{ documentData.receiver.name }}</dd>
            </div>
            <div class="dte-definition-list__row">
              <dt>Direccion</dt>
              <dd>
                {{ documentData.receiver.address }}
                <template v-if="documentData.receiver.addressSecondary">
                  <br />
                  {{ documentData.receiver.addressSecondary }}
                </template>
              </dd>
            </div>
            <div class="dte-definition-list__row" v-if="showEconomicActivity && documentData.receiver.activity">
              <dt>{{ economicActivityLabel }}</dt>
              <dd>{{ documentData.receiver.activity }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showEntity && documentData.receiver.entity">
              <dt>{{ entityLabel }}</dt>
              <dd>{{ documentData.receiver.entity }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showZone && documentData.receiver.zone">
              <dt>{{ zoneLabel }}</dt>
              <dd>{{ documentData.receiver.zone }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showPaymentStatus && documentData.meta.paymentStatus">
              <dt>{{ paymentStatusLabel }}</dt>
              <dd>{{ isContadoEspecial ? "Cancelada / Contado" : documentData.meta.paymentStatus }}</dd>
            </div>
             <div class="dte-definition-list__row" v-if="documentData?.meta?.invoiceType == 'DNR' && documentData?.jsonPayload?.receptor?.bienTitulo">
              <dt>Bienes remitidos a titulo de</dt>
              <dd>{{ getBienTitulo }}</dd>
            </div>
          </div>

          <div class="dte-definition-list">
            <div class="dte-definition-list__row" v-if="documentData.receiver.documentNumber">
              <dt>{{ documentData.receiver.documentLabel }}</dt>
              <dd>{{ documentData.receiver.documentNumber }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="documentData.receiver.nit">
              <dt>NIT</dt>
              <dd>{{ documentData.receiver.nit }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="documentData.receiver.nrc">
              <dt>NRC</dt>
              <dd>{{ documentData.receiver.nrc }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="documentData.receiver.email">
              <dt>Correo</dt>
              <dd>{{ documentData.receiver.email }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="documentData.receiver.phone">
              <dt>Telefono</dt>
              <dd>{{ documentData.receiver.phone }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showSellerCode && documentData.receiver.sellerCode">
              <dt>{{ sellerCodeLabel }}</dt>
              <dd>{{ documentData.receiver.sellerCode }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showSellerName && documentData.receiver.sellerName">
              <dt>{{ sellerNameLabel }}</dt>
              <dd>{{ documentData.receiver.sellerName }}</dd>
            </div>
            <div class="dte-definition-list__row" v-if="showContact && documentData.receiver.contactName">
              <dt>{{ contactLabel }}</dt>
              <dd>{{ documentData.receiver.contactName }}</dd>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="documentData.thirdPartySale" class="dte-card" :style="compact ? '' : 'grid-column: 1 / -1;'">
      <div class="dte-card__header">Venta por Cuenta de Terceros</div>
      <div class="dte-card__body">
        <div class="dte-definition-list">
          <div class="dte-definition-list__row">
            <dt>NIT</dt>
            <dd>{{ documentData.thirdPartySale.nit }}</dd>
          </div>
          <div class="dte-definition-list__row">
            <dt>Nombre</dt>
            <dd>{{ documentData.thirdPartySale.name }}</dd>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getDteTemplateLabel, isDteTemplateFieldVisible } from "@/helpers/dteTemplateSettings";

export default {
  name: "DteRecipientSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    templateSettings() {
      return this.documentData.templateSettings || {};
    },
    showCustomerCode() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "customerCode");
    },
    showSellerCode() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "sellerCode");
    },
    showSellerName() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "sellerName");
    },
    showContact() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "contact");
    },
    showEntity() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "entity");
    },
    showZone() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "zone");
    },
    showPaymentStatus() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "paymentStatus");
    },
    showEconomicActivity() {
      return isDteTemplateFieldVisible(this.templateSettings, "receiver", "economicActivity");
    },
    customerCodeLabel() {
      return getDteTemplateLabel(this.templateSettings, "customerCode", "Codigo cliente");
    },
    sellerCodeLabel() {
      return getDteTemplateLabel(this.templateSettings, "sellerCode", "Codigo vendedor");
    },
    sellerNameLabel() {
      return getDteTemplateLabel(this.templateSettings, "sellerName", "Nombre vendedor");
    },
    contactLabel() {
      return getDteTemplateLabel(this.templateSettings, "contact", "Contacto");
    },
    entityLabel() {
      return getDteTemplateLabel(this.templateSettings, "entity", "Entidad");
    },
    zoneLabel() {
      return getDteTemplateLabel(this.templateSettings, "zone", "Zona");
    },
    paymentStatusLabel() {
      return getDteTemplateLabel(this.templateSettings, "paymentStatus", "Estado de la factura");
    },
    economicActivityLabel() {
      return getDteTemplateLabel(this.templateSettings, "economicActivity", "Actividad economica");
    },
    getBienTitulo(){
      if(this.documentData?.meta?.invoiceType == 'DNR' && this.documentData?.jsonPayload?.receptor?.bienTitulo){
        const bienTitulo = this.documentData?.jsonPayload?.receptor?.bienTitulo;
        return [
          { id: "01", value: "Depósito" },
          { id: "02", value: "Propiedad" },
          { id: "03", value: "Consignación" },
          { id: "04", value: "Traslado" },
          { id: "05", value: "Otros" },
        ].find(i => i.id == bienTitulo)?.value ?? 'Otros';
      } else return '';
    },
    isContadoEspecial() {
      const diasCredito = this.diferentBetweenDays(
          this.documentData.meta.issueDate,
          this.documentData.meta.dueDate
      );

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      return (
        user?.showcashinvoiceswhen1day &&
        this.documentData?.meta?.paymentStatus === "Crédito" &&
        diasCredito === 1
      );
    },
  },
  methods: {
    diferentBetweenDays(date1, date2) {
        const [d1, m1, a1] = date1.split('/').map(Number);
        const [d2, m2, a2] = date2.split('/').map(Number);

        const f1 = new Date(a1, m1 - 1, d1);
        const f2 = new Date(a2, m2 - 1, d2);

        const diferenciaMs = Math.abs(f2 - f1);
        return Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));
    }
  }
};
</script>
